import { render } from "./MenuSubContent.vue?vue&type=template&id=3ef32022&ts=true"
import script from "./MenuSubContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuSubContent.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/menu/MenuSubContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ef32022"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ef32022', __exports__)) {
    api.reload('3ef32022', __exports__)
  }
  
  module.hot.accept("./MenuSubContent.vue?vue&type=template&id=3ef32022&ts=true", () => {
    api.rerender('3ef32022', render)
  })

}


export default __exports__